import { useGetUnreadActivitiesCountQuery, useGetUnreadTicketsQuery } from 'mmfintech-backend-api'

const POLLING_INTERVAL = 30_000

export const useNotificationsUnreadCount = (enabled = true) => {
  const { data: activities = 0 } = useGetUnreadActivitiesCountQuery(undefined, {
    pollingInterval: POLLING_INTERVAL,
    skip: !enabled
  })
  const { data: unreadTickets } = useGetUnreadTicketsQuery(undefined, {
    pollingInterval: POLLING_INTERVAL,
    skip: !enabled
  })
  const tickets = unreadTickets?.length ?? 0

  return { activities, tickets, total: activities + tickets }
}
